import { render, staticRenderFns } from "./OverpaymentsView.vue?vue&type=template&id=b5cb635a&scoped=true&"
import script from "./OverpaymentsView.vue?vue&type=script&lang=js&"
export * from "./OverpaymentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cb635a",
  null
  
)

export default component.exports